import React, { useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import ModalPortal from 'components/Portal';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

const LightBox = (props) => {
    const { open, callback, children, className, scroll, cross, width, disableClickAway } = props;
    const modalRef = useRef(null);
    const boxRef = useRef(null);

    useEffect(() => {
        return () => enablePageScroll();
    }, [])
    
    useEffect(() => {
        open ? disablePageScroll() : enablePageScroll();
    }, [open])

    const handleToggle = (e) => {
        // if(disableClickAway) return;
        return;
        e.stopPropagation();
        if(!boxRef.current.contains(e.target)) {
            callback({open: false});
        }
    }

    const handleClose = (e) => {
        e.stopPropagation();
        callback({open: false});
    }

    return (
        <ModalPortal>
            <CSSTransition
                in={open}
                timeout={300}
                classNames="lightbox-transition"
                nodeRef={modalRef}
                unmountOnExit
            >
                <div className={`modal-box scroll-${scroll ? scroll : "body"}${className ? ` ${className}` : ''}`} ref={modalRef} onClick={handleToggle} data-scroll-lock-scrollable>
                    <div className="light-box" style={{maxWidth: width}} ref={boxRef}>
                        {children}
                        { cross && <i className="light-box-close" onClick={(e) => handleClose(e)}></i>}
                        <div className="dot dot1"></div>
                        { !cross && <div className="dot dot2"></div> }
                        <div className="dot dot3"></div>
                        <div className="dot dot4"></div>
                    </div>
                </div>
            </CSSTransition>
        </ModalPortal>
    )
}

export default LightBox;